import { HashRouter as Router } from 'react-router-dom';

import './App.scss';
import AppRouters from "./Routers/routers";
import {MainContextProvider} from "@contexts/Contexts";

function App() {
  return (
	  <MainContextProvider>
		<Router>
    		<div className="cfs-agenda-app">
				<div className="content">
					<AppRouters />
				</div>
    		</div>
		</Router>
	  </MainContextProvider>
  );
}

export default App;
